// generated by i18n

export const supportedLngs = [
  'en',
  'bg',
  'cs',
  'de',
  'dk',
  'el',
  'en-GB',
  'es-419',
  'es-MX',
  'es',
  'et',
  'fi',
  'fr-CA',
  'fr',
  'hr',
  'hu',
  'is',
  'it',
  'lt',
  'lv',
  'nb-NO',
  'nl',
  'pl',
  'pt-BR',
  'pt',
  'ro',
  'sk',
  'sl',
  'sv',
  'tr',
  'uk',
];
